import React from 'react';
import styled from 'styled-components';

import {useSelector} from 'react-redux';

import {
  ratingAndReviewsBreakupSelector,
  reviewRatingSelector
} from '../../selectors';

import {scrollToEl, detailsNavigationIdsAndValues} from '../../details.config';
import getRatingsColor from '../../../../../shared/utils/getRatingsColor';

function ReviewInfo() {

  const {hotelReviewRating, numberOfReviews} = useSelector(reviewRatingSelector);

  const ratings = useSelector(ratingAndReviewsBreakupSelector);

  return (
    <RatingTopBlock onClick={e => {
      e.preventDefault();
      scrollToEl(detailsNavigationIdsAndValues.guestReviews.id);
    }}>
      <RatingInfoHeadWrap>
        <RatingInfoWrap>
          <UserReviewHeadText>User Rating</UserReviewHeadText>
          <BasedText>Based on {numberOfReviews} ratings</BasedText>
        </RatingInfoWrap>
        <RatingWrap>
          <AvgRating bgColor={getRatingsColor(hotelReviewRating)}>{hotelReviewRating ? hotelReviewRating : '-'}</AvgRating>
        </RatingWrap>
      </RatingInfoHeadWrap>

      <RatingBreakUp>
        {ratings && Object.keys(ratings).length && Object.keys(ratings).map(key => {
          const rating = ratings[key];
          if (rating) {
            return (<BreakupWrap key={key}>
              <BreakupAvg>{rating}</BreakupAvg>
              <BreakUpText>{key}</BreakUpText>
            </BreakupWrap>);
          }
        })}
      </RatingBreakUp>

    </RatingTopBlock>
  );
}

export default ReviewInfo;

export const RatingTopBlock  = styled.div(
  props => `
      width: 100%;
      display: flex;  
      flex-direction: column;
      border: 1px solid ${props.theme.colors.grey.lightdd};
  `
);

export const RatingInfoHeadWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;  
      padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
      border-bottom: 1px solid ${props.theme.colors.grey.lightdd};
  `
);

export const RatingInfoWrap = styled.div(
  props => `
      width: 80%;
      display: flex;
      flex-direction: column;  
  `
);

export const UserReviewHeadText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font16}
      color: ${props.theme.colors.grey.base};
      font-weight: ${props.theme.font.fontWeight.black};  
  `
);

export const BasedText = styled.p(
  props => `
      font-size: ${props.theme.font.small.font11}
      color: ${props.theme.colors.grey.light9b};
      padding-top: ${props.theme.spacing.small.s2};
  `
);

export const RatingWrap = styled.div(
  props => `
      width: 20%;
      display: flex;
      justify-content: flex-end;
  `
);

export const AvgRating = styled.p(
  props => `
      display: flex;
      padding: ${props.theme.spacing.small.s6};
      background-color: ${props.bgColor || props.theme.colors.green.base};
      border-radius: ${props.theme.misc.borderRadius.base};
      font-size: ${props.theme.font.large.font15};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.black};  
      width: 4rem;
      justify-content: center;
  `
);

export const RatingBreakUp = styled.div(
  props => `
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;  
      height:6.3rem;
      align-items: center;
  `
);

export const BreakupWrap = styled.div(
  props => `
      width:30%;
      display: flex;
      flex-direction: column;  
      align-items: center;
      justify-content: center;
  `
);

export const BreakupAvg = styled.p(
  props => `
      font-size: ${props.theme.font.large.font20};
      color: ${props.theme.colors.grey.base};
      letter-spacing: ${props.theme.font.letterSpacing.large};
      font-weight: ${props.theme.font.fontWeight.black};  
  `
);

export const BreakUpText = styled.p(
  props => `
      font-size: ${props.theme.font.small.font11};
      color: ${props.theme.colors.grey.base};
      letter-spacing: ${props.theme.font.letterSpacing.base};
      text-transform: ${props.theme.font.textTransform.upper};
  `
);
